module.exports = __webpack_public_path__ + "static/img/CleopatrasTreasure-zh.5966de65.png";